/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/CardHint',[
        'absolute',
        'pixi',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Tween/Tween'],
    function (Absolute, PIXI, SpriteNode, Tween) {
        "use strict";

        var CardHint = function (path, dcpath) {
            this.initCardHint(path, dcpath);
        };

        CardHint.constructor = CardHint;
        CardHint.prototype = Object.create(SpriteNode.prototype);

        // public const
        CardHint.TexturePath = "hint_highlight";
        CardHint.DCTexturePath = "goal_glow";

        // private const

        // copied from CardView - not included to avoid circular reference
        var CardView = {
            ScaleFactor: 156 / 384,
            HintScale: 2.52
        };
        
        CardHint.prototype.initCardHint = function (path, dcpath) {
            if (dcpath) {
                SpriteNode.call(this, dcpath);
            } else {
                SpriteNode.call(this, path);
            }

            this.ScaleUniform = CardView.ScaleFactor * CardView.HintScale;
            if (Absolute.Platform.isMobile()) {
                this.ScaleY = CardView.ScaleFactor * 2.9;
            }

            this.TextureAlphaEnabled = true;
            this.InputEnabled = false;
            this.Visible = false;

            this._tween = null; // Tween
            this._pulse = new SpriteNode(path);

            if (dcpath) {
                this._pulse.Visible = true;
                this._pulse.ScaleUniform = 1;
                this._pulse.Alpha = 1;
            }

            this.AddChild(this._pulse);
        };

        CardHint.prototype.AnimatePulse = function () {
            if (this._tween == null) {
                var PulseScale = new PIXI.Point(1.15, 1.15),
                    PulseInterval = 0,
                    PulseDuration = 0.8;
                this.children[0].visible = true;
                this._pulse.ScaleUniform = 1;
                this._pulse.Alpha = 0.8;

                var properties = new Tween.TweenProperties();
                properties.NumLoops = -1;
                this._tween = Tween.Start(this._pulse, properties)
                    .ScaleTo(new PIXI.Point(1, 1), 0).And().FadeTo(0.8, 0).Then()
                    .ScaleTo(PulseScale, PulseDuration, TWEEN.Easing.Cubic.Out)
                    .And().FadeTo(0, PulseDuration, TWEEN.Easing.Cubic.Out)
                    .Wait(PulseInterval);
            }
        };

        CardHint.prototype.AnimatePulseOnce = function () {
            if (this.tweenIsRunning) return;
            this.children[0].visible = false;
            var PulseScale = new PIXI.Point(1.4, 1.4),
                scaleDuration = 2.4,
                fadeDuration = 0.8;
            setTimeout(function () {
                if (this._tween) {
                    this.tweenIsRunning = false;
                    this.StopPulse();
                }
            }.bind(this), scaleDuration * 200);
            this.tweenIsRunning = true;
            this._pulse.ScaleUniform = 1;
            this._pulse.Alpha = 0.8;
            var properties = new Tween.TweenProperties();
            properties.NumLoops = 0;
            this._tween = Tween.Start(this._pulse, properties)
                .ScaleTo(PulseScale, scaleDuration, TWEEN.Easing.Cubic.Out)
                .And().FadeTo(0, fadeDuration, TWEEN.Easing.Cubic.Out);
        };

        CardHint.prototype.StopPulse = function () {
            if (this._tween != null) {
                this._tween.Stop(false);
            }
            Tween.RemoveTween(this._pulse, this._tween);
            this._tween = null;
        };

        return CardHint;

    });
